import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';

export function useResendInvitation() {
  const { query } = useApi();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string): Promise<{ message: string }> => {
      return query({
        path: `v1/merchant/users/${id}/invitations/resend`,
        opt: {
          method: 'GET',
        },
      });
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: queryKeys.merchantUsers });
    },
  });

  return {
    mutate,
    isPending,
  };
}
